import { render } from "./padel-tooltip.template.html?vue&type=template&id=87bd5e94&scoped=true"
import script from "./PadelTooltip.vue?vue&type=script&lang=ts"
export * from "./PadelTooltip.vue?vue&type=script&lang=ts"

import "./PadelTooltip.vue?vue&type=style&index=0&id=87bd5e94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-87bd5e94"

export default script